<script setup lang="ts">
import $ from 'jquery';
import type { PropType } from 'vue';
import { nextTick, onBeforeMount, onMounted, shallowRef, unref, watch } from 'vue';

import { addInputmask } from '#public/commons-global';
import { useJqueryEventListener } from '#public_ts/composables';

const props = defineProps({
    modelValue: { type: [String, Number, null] as PropType<string | number | null | undefined>, required: false, default: undefined },
    plain: { type: Boolean as PropType<boolean | undefined>, required: false, default: undefined },
});
const emit = defineEmits<{
    (event: 'update:modelValue', value: string): void;
}>();

const inputElement = shallowRef<HTMLElement | undefined>();

onMounted(() => {
    $(() => {
        const _inputElement = unref(inputElement);
        if(!_inputElement) return;
        addInputmask($(_inputElement));
        $(_inputElement).val(props.modelValue ?? '');
    });
});

onBeforeMount(() => {
    const _inputElement = unref(inputElement);
    if(!_inputElement) return;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ($(_inputElement) as any).inputmask('remove');
});

watch(() => props.modelValue, (val) => {
    const _inputElement = unref(inputElement);
    if(!_inputElement) return;
    $(_inputElement).val(val ?? '');
});

function updateValue() {
    const _inputElement = unref(inputElement);
    if(!_inputElement) return;
    emit('update:modelValue', String($(_inputElement).val()));
}

useJqueryEventListener(inputElement, 'blur autoformat auto-changed', () => {
    nextTick(() => {
        const _input = unref(inputElement);
        if(_input) {
            const val = $(_input).val();
            if((val !== undefined) && (typeof (val) === 'string') && (val !== props.modelValue)) {
                updateValue();
            }
        }
    });
});
</script>

<template>
    <input
        ref="inputElement"
        type="text"
        class="inputmask"
        :class="props.plain ? '' : 'form-control'"
        @input="updateValue"
    >
</template>
